import {
    HIDE_MESSAGE,
    INIT_URL,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SIGNIN_USER,
    SIGNIN_USER_SUCCESS,
    SIGNIN_USER_FAILED,
    SIGNOUT_USER_SUCCESS,
    VERIFY_OTP,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAILED,
    GET_LIST_OF_COUNTRIES,
    GET_LIST_OF_COUNTRIES_SUCCESS,
    GET_LIST_OF_COUNTRIES_FAILED,
    RESET_AUTH_INFO
} from "constants/ActionTypes";

const INIT_STATE = {
    loader: false,
    countries_list: [],
    alertMessage: '',
    showMessage: false,
    initURL: '/',
    signing_up: false,
    signup_succesfull: false,
    email: '',
    enter_otp: false,
    otp_verified: false,
    signup_success_message: "Congratulations. You already made it. Please verify your email address and we will contact you soon.",
    authUser: localStorage.getItem('user_id'),
    is_authenticated: false,
    verifying_otp: false,
    sign_in_error_message: "",
    error_details: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SIGNIN_USER: {
            return {
                ...state,
                loader: true,
                is_authenticating: true,
            };
            // break;
        }
        case SIGNIN_USER_SUCCESS: {
            return {
                ...state,
                loader: false,
                authUser: action.payload,
                email: action.payload.email,
                otp: action.payload.otp,
                is_authenticated: true,
                is_authorized: true,
                is_authenticating: false,
                enter_otp: true,
                otp_verified: false,
                sign_in_error_message: "",
                error_details: null
            }
        }
        case SIGNIN_USER_FAILED: {
            return {
                ...state,
                loader: false,
                is_authenticated: false,
                is_authorized: false,
                is_authenticating: false,
                enter_otp: false,
                error_details: action.payload,
            }
        }
        case INIT_URL: {
            return {
                ...state,
                initURL: action.payload
            }
        }
        case SIGNOUT_USER_SUCCESS: {
            return {
                ...state,
                authUser: null,
                initURL: '/app/dashboard/default',
                loader: false
            }
        }

        case SHOW_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            }
        }
        case HIDE_MESSAGE: {
            return {
                ...state,
                alertMessage: '',
                showMessage: false,
                loader: false
            }
        }

        case ON_SHOW_LOADER: {
            return {
                ...state,
                loader: true
            }
        }
        case ON_HIDE_LOADER: {
            return {
                ...state,
                loader: false
            }
        }
        case VERIFY_OTP: {
            return {
                ...state,
                verifying_otp: true
            }
        }

        case VERIFY_OTP_SUCCESS: {
            return {
                ...state,
                user: action.payload,
                otp_verified: true,
                verifying_otp: false,
                error_details: null
            }
        }

        case VERIFY_OTP_FAILED: {
            return {
                ...state,
                otp_verified: false,
                verifying_otp: false,
                error_details: action.error
            }
        }

        case GET_LIST_OF_COUNTRIES: {
            return {
                ...state,
                fetching_countries_list: true,
            }
        }

        case GET_LIST_OF_COUNTRIES_SUCCESS: {
            // console.log(action.payload)
            return {
                ...state,
                fetching_countries_list: false,
                countries_list: action.payload.countries_list,
            }
        }

        case GET_LIST_OF_COUNTRIES_FAILED: {
            return {
                ...state,
                error: "fetch_countries_list_failed",
                failed_to_fetch_countries_list: true
            }
        }

        case RESET_AUTH_INFO: {
            return {
                ...state,
                enter_otp: false,
                otp_verified: false,
                error_details: null
            }
        }

        default:
            return state;
    }
}
